export function getProductFallbackImageUrl() {
  if (process.env.NUXT_ENV_BS_BUILD_MODULE === 'mabu') {
    return require('~/assets/images/mb_no-picture.jpg')
  } else {
    return require('~/assets/images/no-picture.jpg')
  }
}
